import React from 'react';
import classnames from 'classnames';
import LiteratureDumbView from '../../../../DeviationViews/Dumbo/Literature';
import EditorDeviationLink from '../../_partials/DeviationLink';
import { getSizeForFreeform } from '../../helpers';
import s from './Literature.scss';
const LiteratureMonoReactView = ({ config: { alignment, link, width: configuredWidth }, settings, deviation })=>{
    let size = {
        width: 389,
        height: 343
    };
    if (alignment !== 'center') {
        size = {
            width: 350,
            height: 313
        };
    }
    // Handle resizing
    size = getSizeForFreeform(size, configuredWidth);
    if (settings && settings.showMediaAlwaysSmall) {
        // https://zpl.io/awYRXAn
        size = {
            width: 180,
            height: 125
        };
    }
    return /*#__PURE__*/ React.createElement("div", {
        className: classnames(s['root'], s['normal'], alignment && s[alignment], settings && settings.showMediaAlwaysSmall && s['small']),
        style: {
            width: size.width
        }
    }, /*#__PURE__*/ React.createElement(EditorDeviationLink, {
        link: link,
        deviation: deviation
    }, /*#__PURE__*/ React.createElement(LiteratureDumbView, {
        width: size.width,
        height: size.height,
        deviation: deviation
    })));
};
LiteratureMonoReactView.displayName = 'LiteratureMonoReactView';
export default LiteratureMonoReactView;

//# sourceMappingURL=Literature.js.map